// The transmittals view of the Files workspace lives in the address (`?view=transmittals`, and
// `&transmittal=<id>` for the open one), so it can be shared and survives a reload. The workspace
// is used by a project's Files tab and by a space's Documents tab: the hook reads the search
// params of whichever route is showing it.
import { IdSchema } from '@batiflow/contracts';
import { useNavigate, useSearch } from '@tanstack/react-router';

export interface TransmittalsViewState {
  /** The transmittals list replaces the folder content. */
  open: boolean;
  /** The transmittal whose detail is open, when there is one. */
  transmittalId: string | null;
  /** Opens or closes the view; `transmittalId` also opens that transmittal's detail. */
  show: (open: boolean, transmittalId?: string | null) => void;
}

type SearchPatch = Record<string, unknown>;

export function useTransmittalsView(): TransmittalsViewState {
  const search: SearchPatch = useSearch({ strict: false });
  const navigate = useNavigate();
  const open = search.view === 'transmittals';
  const id = IdSchema.safeParse(search.transmittal);
  return {
    open,
    transmittalId: open && id.success ? id.data : null,
    show: (next, transmittalId = null) => {
      void navigate({
        to: '.',
        search: ((previous: SearchPatch) => ({
          ...previous,
          view: next ? 'transmittals' : undefined,
          transmittal: next && transmittalId ? transmittalId : undefined,
        })) as never,
      });
    },
  };
}
